<template>
  <el-container class="body_container">
    <el-header style="height: 50px;padding:0px">
      <el-row type="flex">
        <el-col class="body_title">角色管理</el-col>
        <el-col style="text-align: right">
          <el-button @click="add" type="primary">新增</el-button>
        </el-col>
      </el-row>
    </el-header>
    <el-main class="search_result">
      <el-table :data="roleData.list">
        <!--<el-table-column prop="id" label="角色ID" width="100px"></el-table-column>-->
        <el-table-column prop="name" label="角色名称" min-width="120px"></el-table-column>
        <el-table-column prop="code" label="角色代码" min-width="120px"></el-table-column>
        <el-table-column prop="createdBy" label="创建人" min-width="100px"></el-table-column>
        <el-table-column prop="createdTime" label="创建时间" min-width="165px"></el-table-column>
        <el-table-column prop="updatedBy" label="更新人" min-width="100px"></el-table-column>
        <el-table-column prop="updatedTime" label="更新时间" min-width="170px"></el-table-column>
        <el-table-column prop="handle" label="操作" width="80px">
          <template slot-scope="scope">
            <!--<i class="el-icon-plus" @click="savePermission(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>-->
            <!--&nbsp;&nbsp;-->
            <i class="el-icon-edit" @click="editRole(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
            &nbsp;
            <i class="el-icon-delete" @click="delRole(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-pagination class="page"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :page-size="roleData.rows"
                   :current-page="roleData.page"
                   layout="prev, pager, next, jumper"
                   :total="roleData.total">
    </el-pagination>
    <el-dialog title="角色信息" :visible.sync="roleDialog">
      <el-form :model="role" size="small">
        <el-form-item label="角色名称" label-width="70px">
          <el-input v-model="role.name" type="text"></el-input>
        </el-form-item>
        <el-form-item label="角色代码" label-width="70px">
          <el-input v-model="role.code" placeholder="角色代码以ROLE_开头" type="text"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('role')">{{'取消'}}</el-button>
        <el-button type="primary" @click="save">{{'保存'}}</el-button>
      </div>
    </el-dialog>
    <el-dialog title="分配权限" :visible.sync="resourceDialog">
      <el-form :model="roleAndResource" size="small">
        <el-form-item label="角色名称" label-width="70px">
          <el-input v-model="roleAndResource.name" readonly type="text"></el-input>
        </el-form-item>
        <el-form-item label="角色代码" label-width="70px">
          <el-input v-model="roleAndResource.code" readonly placeholder="角色代码以ROLE_开头" type="text"></el-input>
        </el-form-item>
        <el-form-item>
          <el-table :data="roleAndResource.resourceData">
            <el-table-column prop="name" label="资源名称" width="100px"></el-table-column>
            <el-table-column prop="code" label="资源代码" width="100px"></el-table-column>
            <el-table-column prop="url" label="资源地址" width="150px"></el-table-column>
            <el-table-column prop="category" label="类别" width="100px"></el-table-column>
            <el-table-column type="selection"></el-table-column>
            <!--<el-table-column prop="handle" label="操作">-->
              <!--<template slot-scope="scope">-->
                <!--<el-button class="el-icon-edit" @click="editResource(scope.row)" style="font-size: 20px"></el-button>-->
                <!--&nbsp;-->
                <!--<el-button class="el-icon-delete" @click="delResource(scope.row)" style="font-size: 20px"></el-button>-->
              <!--</template>-->
            <!--</el-table-column>-->
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelRoleAndResource">{{'取消'}}</el-button>
        <el-button type="primary" @click="saveRoleAndResource">{{'保存'}}</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
  import role from '@/api/role'
  export default {
    name: 'Role',
    data() {
      return {
        roleData: {
          page: 1,
          rows: 10,
          total: 0,
          list: []
        },
        page: 1,
        rows: 10,
        roleDialog: false,
        role: {},
        roleName: '',
        resourceDialog: false,
        roleAndResource: {
          name: '',
          code: '',
          resourceData: []
        }
      }
    },
    methods: {
      reload() {
        role.find({name: ''}).then(res => {
          this.roleData = res.data.data
        })
      },
      add() {
        this.roleDialog = true
        this.role = {}
      },
      handleSizeChange(val) {
        this.page = val
        this.reload()
      },
      handleCurrentChange(val) {
        this.page = val
        this.reload()
      },
      save() {
        console.log(this.role)
        role.saveRole(this.role).then(res => {
          this.roleDialog = false
          this.role = {}
          this.reload()
        })
      },
      cancel() {
        this.roleDialog = false
        this.role = {}
      },
      editRole(row) {
        this.roleDialog = true
        this.role = row
      },
      delRole(row) {
        //删除时,先判断该角色是否已经分配,如果已分配,就要提示先删除该角色下的用户
        this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          role.delRole({id: row.id}).then(res => {
            this.$message({
              type: 'success',
              message: res.data.message
            })
            this.reload()
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      savePermission (row) {
        this.resourceDialog = true
        this.roleAndResource.name = row.name
        this.roleAndResource.code = row.code
        role.findResourceByRoleId({id: row.id}).then(res => {
          // console.log(res.data.data)
          this.roleAndResource.resourceData = res.data.data
        })
      },
      cancelRoleAndResource () {
        this.resourceDialog = false
      },
      saveRoleAndResource () {}
    },
    created() {
      this.reload()
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/system/Role.vue